/* AAD redesign behavior: navigation, drawers, filter forms, product options and gallery. */
(function () {
  const $ = (s, r) => (r || document).querySelector(s);
  const $$ = (s, r) => Array.from((r || document).querySelectorAll(s));

  /* ---------- mega menu ---------- */
  function initNav(root) {
    const items = $$('[data-aad-nav-item]', root);
    const closeAll = except => items.forEach(li => {
      if (li === except) return;
      const b = $('button', li), p = $('.aad-mega', li);
      if (b) b.setAttribute('aria-expanded', 'false');
      if (p) p.classList.remove('is-open');
    });
    const open = li => { closeAll(li); $('button', li).setAttribute('aria-expanded', 'true'); $('.aad-mega', li).classList.add('is-open'); };
    let t;
    const cancel = () => clearTimeout(t);
    const touch = e => e.pointerType === 'touch';
    items.forEach(li => {
      const b = $('button', li);
      if (!b) { li.addEventListener('pointerenter', e => { if (!touch(e)) { cancel(); closeAll(); } }); return; }
      b.addEventListener('click', () => { cancel(); b.getAttribute('aria-expanded') === 'true' ? closeAll() : open(li); });
      li.addEventListener('pointerenter', e => { if (!touch(e)) { cancel(); open(li); } });
      li.addEventListener('pointerleave', e => { if (!touch(e)) { cancel(); t = setTimeout(() => closeAll(), 160); } });
      li.addEventListener('focusout', e => { if (e.relatedTarget && !li.contains(e.relatedTarget) && b.getAttribute('aria-expanded') === 'true') closeAll(); });
    });
    document.addEventListener('keydown', e => {
      if (e.key !== 'Escape') return;
      const openBtn = $('[aria-expanded="true"]', root);
      closeAll();
      if (openBtn) openBtn.focus();
    });
    document.addEventListener('click', e => { if (!root.contains(e.target)) closeAll(); });
  }

  /* ---------- drawers ---------- */
  document.addEventListener('click', e => {
    const opener = e.target.closest('[data-aad-open]');
    if (opener) { const d = document.getElementById(opener.dataset.aadOpen); if (d && d.showModal) d.showModal(); return; }
    const closer = e.target.closest('[data-aad-close]');
    if (closer) { closer.closest('dialog').close(); return; }
    if (e.target.tagName === 'DIALOG' && e.target.classList.contains('aad-drawer')) e.target.close();
  });

  /* ---------- filters: native Shopify filter URLs, submitted as a plain GET form ---------- */
  function submitFilters(form) {
    const params = new URLSearchParams();
    new FormData(form).forEach((v, k) => { if (v !== '') params.append(k, v); });
    location.href = form.getAttribute('action') + (params.toString() ? '?' + params.toString() : '');
  }
  $$('[data-aad-filter-form]').forEach(form => {
    if (form.dataset.aadAuto === 'false') {
      form.addEventListener('submit', e => { e.preventDefault(); submitFilters(form); });
      return;
    }
    form.addEventListener('change', e => { if (e.target.matches('input[type=checkbox],input[type=number],select')) submitFilters(form); });
    form.addEventListener('submit', e => { e.preventDefault(); submitFilters(form); });
  });
  $$('[data-aad-sort]').forEach(sel => sel.addEventListener('change', () => {
    const u = new URL(location.href); u.searchParams.set('sort_by', sel.value); u.searchParams.delete('page'); location.href = u.toString();
  }));

  /* ---------- product gallery: swipeable slides, thumbnails that follow, videos that only play on request ---------- */
  function initGallery(g) {
    const track = $('[data-aad-pg-track]', g); if (!track) return null;
    const slides = $$('[data-aad-slide]', g), thumbs = $$('[data-aad-pg-thumb]', g);
    const strip = $('[data-aad-pg-strip]', g), note = $('[data-aad-pg-note]', g);
    const reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
    let cur = null, ticking = false, settle = 0;
    const shown = () => slides.filter(s => !s.hidden);
    /* Height the strip and everything above the gallery take, so the main view can shrink to fit the screen. */
    function measure() {
      g.style.setProperty('--aad-pg-strip', (strip ? strip.offsetHeight + 10 : 0) + (note && note.offsetParent ? note.offsetHeight + 8 : 0) + 'px');
      g.style.setProperty('--aad-pg-top', Math.round(g.getBoundingClientRect().top + scrollY) + 'px');
    }
    function stop(except) {
      slides.forEach(s => {
        if (s === except) return;
        const v = $('video', s); if (v && !v.paused) v.pause();
        const f = $('iframe', s); if (f && f.dataset.live) { f.src = f.src; delete f.dataset.live; }
      });
    }
    function mark(slide) {
      if (!slide) return;
      cur = slide;
      const list = shown(), at = list.indexOf(slide);
      thumbs.forEach(t => t.setAttribute('aria-current', t.dataset.media === slide.dataset.media ? 'true' : 'false'));
      stop(slide);
      if (note) note.textContent = (at + 1) + ' of ' + list.length + '. Swipe, or tap a thumbnail.';
      /* Keep the chosen thumbnail in view by scrolling the strip itself, never the page. */
      const t = thumbs.find(x => x.dataset.media === slide.dataset.media);
      if (t && strip && strip.scrollWidth > strip.clientWidth + 1) {
        const left = t.offsetLeft - strip.offsetLeft - (strip.clientWidth - t.offsetWidth) / 2;
        strip.scrollTo({ left: Math.max(0, left), behavior: reduce ? 'auto' : 'smooth' });
      }
    }
    function go(slide, smooth) {
      if (!slide) return;
      track.scrollTo({ left: slide.offsetLeft, behavior: smooth && !reduce ? 'smooth' : 'auto' });
      mark(slide);
    }
    thumbs.forEach(t => t.addEventListener('click', () => go(slides.find(s => s.dataset.media === t.dataset.media), true)));
    /* A swipe moves the slides; the slide that settles in view becomes the selection. */
    track.addEventListener('scroll', () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        ticking = false;
        clearTimeout(settle);
        settle = setTimeout(() => {
          const list = shown(), w = track.clientWidth || 1;
          const at = list[Math.min(list.length - 1, Math.max(0, Math.round(track.scrollLeft / w)))];
          if (at && at !== cur) mark(at);
        }, 90);
      });
    }, { passive: true });
    track.addEventListener('keydown', e => {
      if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
      const list = shown(), at = list.indexOf(cur) + (e.key === 'ArrowRight' ? 1 : -1);
      if (at < 0 || at >= list.length) return;
      e.preventDefault();
      go(list[at], true);
    });
    $$('iframe', g).forEach(f => f.addEventListener('focus', () => { f.dataset.live = '1'; }));
    /* Playing one video pauses any other; a gallery scrolled off screen pauses its video. */
    $$('video', g).forEach(v => v.addEventListener('play', () => { const s = v.closest('[data-aad-slide]'); if (s !== cur) go(s, false); stop(s); }));
    if ('IntersectionObserver' in window) new IntersectionObserver(es => es.forEach(e => { if (!e.isIntersecting) stop(null); }), { threshold: 0 }).observe(track);
    addEventListener('resize', () => { measure(); if (cur) track.scrollTo({ left: cur.offsetLeft, behavior: 'auto' }); });
    addEventListener('load', measure);
    measure();
    go(slides.find(s => s.dataset.media === g.dataset.lead) || slides[0], false);
    return {
      /* Variant pictures: show only that variant's set, or move to its own picture. */
      only(ids, focus) {
        const keep = ids ? new Set(ids.map(String)) : null;
        slides.forEach(s => { s.hidden = keep ? !keep.has(s.dataset.media) : false; });
        thumbs.forEach(t => { t.hidden = keep ? !keep.has(t.dataset.media) : false; });
        measure();
        go(shown().find(s => s.dataset.media === String(focus)) || shown()[0], false);
      }
    };
  }

  /* ---------- product page ---------- */
  function initProduct(root) {
    const dataEl = $('[data-aad-product-json]', root); if (!dataEl) return;
    const data = JSON.parse(dataEl.textContent);
    const opts = $$('[data-aad-opt]', root);
    const state = opts.map(o => { const on = $('[aria-pressed="true"]', o); return on ? on.dataset.value : null; });
    const optIndex = opts.map(o => +o.dataset.index);
    const fits = (v, upto) => opts.every((o, n) => n >= upto || v.options[optIndex[n]] === state[n]);
    const main = $('[data-aad-main] img', root);
    const thumbs = $$('[data-aad-thumb]', root);
    const galn = $('[data-aad-galn]', root);
    /* The rebuilt product section uses the slide gallery. Review pages keep the older single-image gallery below. */
    const pg = (() => { const g = $('[data-aad-pg]', root); return g ? initGallery(g) : null; })();

    function show(btn) {
      if (!btn) return;
      thumbs.forEach(t => t.setAttribute('aria-current', t === btn ? 'true' : 'false'));
      if (main) { main.src = btn.dataset.full; main.srcset = btn.dataset.srcset || ''; main.alt = btn.dataset.alt || ''; }
      const strip = btn.parentElement;
      if (strip && strip.scrollWidth > strip.clientWidth) strip.scrollTo({ left: btn.offsetLeft - strip.offsetLeft, behavior: 'smooth' });
    }
    thumbs.forEach(t => t.addEventListener('click', () => show(t)));

    function current() { return data.variants.find(v => fits(v, opts.length)) || null; }
    function setGallery(v) {
      if (pg) {
        if (v && v.gallery && v.gallery.length) pg.only(v.gallery);
        else pg.only(null, v && v.media);
        return;
      }
      if (!thumbs.length) return;
      if (v && v.gallery && v.gallery.length) {
        const keep = new Set(v.gallery.map(String));
        let first = null;
        thumbs.forEach(t => { const on = keep.has(t.dataset.media); t.hidden = !on; if (on && !first) first = t; });
        if (galn) galn.textContent = keep.size + ' photos, swipe to see more';
        show(first);
      } else if (v && v.media) {
        show(thumbs.find(t => t.dataset.media === String(v.media)));
      }
    }
    function render(fromUser) {
      /* A value stays selectable only when that pair exists. If the current pick stops existing, move to the first one that does. */
      opts.forEach((o, n) => {
        const btns = $$('[data-value]', o);
        const live = data.variants.filter(v => fits(v, n));
        btns.forEach(b => {
          const ms = live.filter(v => v.options[optIndex[n]] === b.dataset.value);
          b.hidden = ms.length === 0;
          const ok = ms.some(v => v.available);
          b.classList.toggle('is-oos', ms.length > 0 && !ok);
          b.setAttribute('aria-label', b.dataset.value + (ms.length && !ok ? ', sold out' : ''));
          const small = $('small', b);
          if (small) small.textContent = ms.length ? (ok ? ms[0].price_f : 'Sold out') : '';
        });
        if (!live.some(v => v.options[optIndex[n]] === state[n])) {
          const pick = live.find(v => v.available) || live[0];
          if (pick) state[n] = pick.options[optIndex[n]];
        }
        btns.forEach(b => b.setAttribute('aria-pressed', b.dataset.value === state[n] ? 'true' : 'false'));
        const lab = $('[data-aad-opt-val]', o); if (lab) lab.textContent = state[n];
        const note = $('[data-aad-opt-note]', o);
        if (note) {
          const shown = btns.filter(b => !b.hidden).map(b => b.dataset.value);
          note.textContent = n > 0 && shown.length < btns.length ? state[n - 1] + ' comes in ' + shown.join(' and ') + '.' : '';
        }
      });
      const v = current(); if (!v) return;
      const price = $('[data-aad-price]', root);
      if (price) {
        const on = v.compare && v.compare > v.price;
        price.classList.toggle('aad-price--on', !!on);
        price.innerHTML = v.price_f + (on ? '<s>' + v.compare_f + '</s>' : '');
      }
      const stickyPrice = $('[data-aad-sticky-price]', root); if (stickyPrice) stickyPrice.textContent = v.price_f;
      const stock = $('[data-aad-stock]', root);
      if (stock) {
        $('.aad-dot', stock).classList.toggle('aad-dot--no', !v.available);
        $('[data-aad-stock-t]', stock).textContent = data.stock_text || (v.available ? 'In stock' : 'Sold out');
        const sku = $('.aad-sku', stock); if (sku) sku.textContent = v.sku ? '· SKU ' + v.sku : '';
      }
      const id = $('[data-aad-variant-id]', root); if (id) { id.value = v.id; id.dispatchEvent(new Event('change', { bubbles: true })); }
      /* Shopify's installment message follows its variant-id attribute; its form's id field is kept in step too. */
      const payId = $('[data-aad-pay-id]', root); if (payId) payId.value = v.id;
      const terms = $('[data-aad-pay] shopify-payment-terms', root);
      if (terms && terms.getAttribute('variant-id') !== String(v.id)) terms.setAttribute('variant-id', v.id);
      const pay = $('[data-aad-pay]', root); if (pay) pay.hidden = !v.available;
      $$('[data-aad-add]', root).forEach(btn => {
        const off = !v.available || data.preview;
        btn.disabled = off;
        const t = $('span', btn) || btn;
        t.textContent = data.preview ? 'Preview only' : (v.available ? 'Add to cart' : 'Sold out');
      });
      $$('[data-aad-sized]', root).forEach(el => {
        const val = el.dataset['v' + v.id] || '';
        el.textContent = val;
        const cell = el.closest('[data-aad-cell]'); if (cell) cell.hidden = !val;
      });
      $$('[data-aad-size-row]', root).forEach(tr => {
        const on = tr.dataset.size === v.size_value && (!tr.dataset.finish ? !$$('[data-aad-size-row]', root).some(x => x.dataset.size === v.size_value && x.dataset.finish === v.finish_value) : tr.dataset.finish === v.finish_value);
        tr.classList.toggle('on', on);
      });
      const guide = $('[data-aad-size-guide]', root);
      if (guide) {
        const made = new Set(data.variants.filter(x => x.finish_value === v.finish_value).map(x => x.size_value));
        $$('rect', guide).forEach(r => { r.setAttribute('class', r.dataset.size === v.size_value ? 'on' : made.has(r.dataset.size) ? '' : 'off'); });
        $$('text', guide).forEach(t => { t.setAttribute('class', t.dataset.size === v.size_value ? 'on' : ''); });
      }
      if (fromUser) {
        setGallery(v);
        if (!data.preview) { const u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u.toString()); }
      }
    }
    opts.forEach((o, n) => o.addEventListener('click', e => {
      const b = e.target.closest('[data-value]'); if (!b) return;
      state[n] = b.dataset.value; render(true);
    }));
    if (opts.length) { render(false); setGallery(current()); }

    /* quantity */
    const qty = $('[data-aad-qty]', root);
    if (qty) $$('[data-aad-step]', root).forEach(b => b.addEventListener('click', () => {
      qty.value = Math.max(1, (parseInt(qty.value, 10) || 1) + (+b.dataset.aadStep));
    }));

    /* phone: sticky add button appears after the main button scrolls away */
    const sticky = $('[data-aad-sticky]', root), mainBtn = $('.aad-buyform [data-aad-add]', root);
    if (sticky && mainBtn && 'IntersectionObserver' in window) {
      new IntersectionObserver(es => es.forEach(x => sticky.classList.toggle('is-show', !x.isIntersecting && x.boundingClientRect.top < 0))).observe(mainBtn);
      const stickyBtn = $('[data-aad-add]', sticky);
      if (stickyBtn) stickyBtn.addEventListener('click', () => mainBtn.click());
    }
  }

  /* ---------- collection banner video: poster first, video after the page settles, always pausable ---------- */
  function initVideo(el) {
    const id = el.dataset.aadVideo, btn = $('[data-aad-video-toggle]', el), media = $('.aad-chero__media', el);
    if (!id || !media || !btn) return;
    const reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
    const save = navigator.connection && navigator.connection.saveData;
    let frame = null, playing = false, timer = 0, held = false;
    const PAUSE = '<svg viewBox="0 0 16 16" aria-hidden="true"><path d="M4 2h3v12H4zM9 2h3v12H9z"/></svg>';
    const PLAY = '<svg viewBox="0 0 16 16" aria-hidden="true"><path d="M4 2l10 6-10 6z"/></svg>';
    const mark = on => { playing = on; btn.innerHTML = on ? PAUSE : PLAY; btn.setAttribute('aria-label', on ? 'Pause background video' : 'Play background video'); };
    const send = fn => { if (frame && frame.contentWindow) frame.contentWindow.postMessage(JSON.stringify({ event: 'command', func: fn, args: [] }), '*'); };
    function start() {
      frame = document.createElement('iframe');
      frame.className = 'aad-chero__frame';
      frame.title = '';
      frame.tabIndex = -1;
      frame.setAttribute('aria-hidden', 'true');
      frame.setAttribute('allow', 'autoplay; encrypted-media');
      frame.src = `https://www.youtube-nocookie.com/embed/${encodeURIComponent(id)}?autoplay=1&mute=1&loop=1&playlist=${encodeURIComponent(id)}&controls=0&disablekb=1&fs=0&playsinline=1&rel=0&modestbranding=1&iv_load_policy=3&enablejsapi=1&origin=${encodeURIComponent(location.origin)}`;
      frame.addEventListener('load', () => {
        frame.contentWindow.postMessage(JSON.stringify({ event: 'listening' }), '*');
        if (playing) reveal(); else send('pauseVideo');
      });
      media.appendChild(frame);
      mark(true);
    }
    /* YouTube draws its own controls for a few seconds when a video starts or resumes; the poster stays in front until they clear. */
    function reveal() {
      frame.classList.remove('is-on');
      clearTimeout(timer);
      timer = setTimeout(() => frame.classList.add('is-on'), 6000);
    }
    /* A looping video restarts with YouTube's title and buttons on top, so the poster also covers each restart. */
    let length = 0;
    addEventListener('message', e => {
      if (!frame || e.source !== frame.contentWindow || typeof e.data !== 'string') return;
      let info = null;
      try { info = JSON.parse(e.data).info; } catch (err) { return; }
      if (!info || typeof info !== 'object' || !playing) return;
      if (info.duration) length = info.duration;
      if (info.playerState === -1 || (length && length - info.currentTime < 1)) reveal();
    });
    btn.hidden = false;
    btn.addEventListener('click', () => {
      if (!frame) return start();
      if (playing) { held = true; clearTimeout(timer); send('pauseVideo'); mark(false); }
      else { held = false; send('playVideo'); reveal(); mark(true); }
    });
    /* A collection banner band falls back to its full artwork, the same as the store-hosted videos. */
    const spot = el.closest('.aad-spot');
    if ((reduce || save) && spot) { spot.classList.add('is-still'); return; }
    if (reduce || save) { mark(false); return; }
    mark(true);
    /* A spotlight further down the page plays only while it is on screen, unless the shopper paused it. */
    if ('aadVideoInview' in el.dataset && 'IntersectionObserver' in window) {
      new IntersectionObserver(es => es.forEach(e => {
        if (held) return;
        if (e.isIntersecting) { if (!frame) start(); else { send('playVideo'); reveal(); mark(true); } }
        else if (frame) { clearTimeout(timer); send('pauseVideo'); }
      }), { threshold: 0.35 }).observe(el);
      return;
    }
    const later = () => start();
    if (document.readyState === 'complete') (window.requestIdleCallback || setTimeout)(later, { timeout: 1500 });
    else addEventListener('load', () => (window.requestIdleCallback || setTimeout)(later, { timeout: 1500 }), { once: true });
  }

  /* ---------- collection spotlight video: loads when on screen, one plays at a time, the artwork is the fallback ---------- */
  let spotPlaying = null;
  function initSpot(band) {
    const video = $('video', band), btn = $('[data-aad-spot-toggle]', band), spot = band.closest('.aad-spot');
    if (!video || !btn) return;
    const reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
    const save = navigator.connection && navigator.connection.saveData;
    const still = () => { if (spot) spot.classList.add('is-still'); };
    if (reduce || save) return still();
    const PAUSE = '<svg viewBox="0 0 16 16" aria-hidden="true"><path d="M4 2h3v12H4zM9 2h3v12H9z"/></svg>';
    const PLAY = '<svg viewBox="0 0 16 16" aria-hidden="true"><path d="M4 2l10 6-10 6z"/></svg>';
    let held = false;
    const mark = on => { btn.innerHTML = on ? PAUSE : PLAY; btn.setAttribute('aria-label', on ? 'Pause background video' : 'Play background video'); };
    const play = () => {
      if (!video.src) video.src = band.dataset.aadSpotVideo;
      if (spotPlaying && spotPlaying !== video) spotPlaying.pause();
      spotPlaying = video;
      const p = video.play();
      if (p && p.catch) p.catch(() => {});
      mark(true);
    };
    video.addEventListener('error', still);
    btn.hidden = false;
    btn.addEventListener('click', () => {
      if (!video.paused) { held = true; video.pause(); mark(false); }
      else { held = false; play(); }
    });
    if (!('IntersectionObserver' in window)) return play();
    new IntersectionObserver(es => es.forEach(e => {
      if (held) return;
      if (e.isIntersecting) play();
      else if (!video.paused) video.pause();
    }), { threshold: 0 }).observe(band);
  }

  /* ---------- related products: Shopify's own recommendations endpoint ---------- */
  function initRelated(el) {
    const url = el.dataset.url; if (!url) return;
    fetch(url).then(r => r.text()).then(html => {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const inner = doc.querySelector('[data-aad-related]');
      if (inner && inner.querySelector('.aad-card')) el.innerHTML = inner.innerHTML;
      else el.closest('.shopify-section').hidden = true;
    }).catch(() => {});
  }

  /* Shipping and returns links open the product page's own Shipping & returns section. Without it, or without script, they go to the policy pages. */
  function openShipping(focus) {
    const d = document.getElementById('aad-shipping-returns'); if (!d) return false;
    d.open = true;
    d.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
    if (focus) { const s = $('summary', d); if (s) s.focus({ preventScroll: true }); }
    return true;
  }
  document.addEventListener('click', e => {
    const a = e.target.closest && e.target.closest('a[data-aad-acc]');
    if (a && openShipping(true)) { e.preventDefault(); history.replaceState(null, '', '#aad-shipping-returns'); }
  });

  function boot() {
    document.documentElement.classList.add('js');
    if (location.hash === '#aad-shipping-returns') openShipping(false);
    $$('[data-aad-nav]').forEach(initNav);
    $$('[data-aad-pdp]').forEach(initProduct);
    $$('[data-aad-related-load]').forEach(initRelated);
    $$('[data-aad-video]').forEach(initVideo);
    $$('[data-aad-spot-video]').forEach(initSpot);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', e => {
    $$('[data-aad-nav]', e.target).forEach(initNav);
    $$('[data-aad-pdp]', e.target).forEach(initProduct);
    $$('[data-aad-related-load]', e.target).forEach(initRelated);
    $$('[data-aad-video]', e.target).forEach(initVideo);
    $$('[data-aad-spot-video]', e.target).forEach(initSpot);
  });
})();
